import { useEffect, useState } from "react";

const FALLBACK_CURRENCIES = ["INR", "USD", "AED", "GBP", "EUR"];

/* Fetches the full currency list from the partner API (public, no auth —
   CORS is open). Falls back to a small hardcoded list if that's ever down,
   so order creation/editing never gets blocked on it. */
const useCurrencies = () => {
  const [currencies, setCurrencies] = useState(FALLBACK_CURRENCIES);

  useEffect(() => {
    let cancelled = false;
    fetch("https://partnerapi.dentaldost.co/countries/all-currencies")
      .then((res) => res.json())
      .then((data) => {
        if (cancelled || !Array.isArray(data)) return;
        const codes = [...new Set(data.map((entry) => entry.code).filter(Boolean))].sort();
        if (codes.length) setCurrencies(codes);
      })
      .catch((error) => {
        console.error("Error fetching currency list, using fallback:", error);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return currencies;
};

export default useCurrencies;
